module.exports = __webpack_public_path__ + "static/videoPoster-4267f6d7c25c5dc33b8b2f89b94090cf.jpg";